<template>
	<LabeledObject>
		<template #label>{{ trans('general.sort.title') }}</template>
		<select v-model="column" @change.stop="changePage">
			<option v-for="option in sortOptions" :key="`sort-options-${option}`" :value="option">{{ trans(`general.sort.options.${option}`) }}</option>
		</select>
	</LabeledObject>
</template>
<script setup lang="ts">
import {trans} from 'laravel-vue-i18n'
import {router} from '@inertiajs/vue3'
import {defineProps, ref, type Ref} from 'vue'
import LabeledObject from '@/Components/UI/LabeledObject.vue'

const props = defineProps<{
	column:string,
	sortOptions:Array<string>,
}>()

const column:Ref<string> = ref(props.column)

function changePage():void{
	router.get('', {
		column: column.value,
	}, {
		preserveScroll: true,
	})
}
</script>
